import 'css-chunksrc/client/scenes/wbs/task/allocationsList/details/styles.scss';export default {
  "allocations": "_allocations_1tdyi_1",
  "main": "_main_1tdyi_5",
  "groupMain": "_groupMain_1tdyi_11",
  "item": "_item_1tdyi_15",
  "groupItem": "_groupItem_1tdyi_19",
  "placeholder": "_placeholder_1tdyi_26",
  "addAllocation": "_addAllocation_1tdyi_34",
  "iconBox": "_iconBox_1tdyi_41",
  "icon": "_icon_1tdyi_41",
  "list": "_list_1tdyi_56",
  "top": "_top_1tdyi_61",
  "bottom": "_bottom_1tdyi_67"
};